(() => {
  'use strict';
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];
  const config = JSON.parse($('#pc-shop-config').textContent);
  const root = config.root;
  const money = cents => new Intl.NumberFormat('fr-FR', {style: 'currency', currency: config.currency}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const drawer = $('#cart-drawer');
  drawer.inert = true;
  const backdrop = $('.cart-drawer-backdrop');
  let cart = config.cart;
  let lastFocus;
  let busy = false;
  const showError = (text, target = $('[data-cart-error]')) => {
    if (target) { target.textContent = text; target.hidden = !text; }
  };
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      headers: {'Accept': 'application/json', ...(body === undefined ? {} : {'Content-Type': 'application/json'})},
      ...(body === undefined ? {} : {body: JSON.stringify(body)})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Impossible de mettre à jour le panier. Réessaie.');
    return data;
  }
  function render() {
    $('[data-cart-items]').innerHTML = cart.items.map(item => `<div class="cart-drawer__item">
      <div class="cart-drawer__item-thumb"><img src="${escape(item.image || config.bottle)}" width="70" height="100" alt="${escape(item.product_title)}"></div>
      <div class="cart-drawer__item-meta"><div class="cart-drawer__item-head"><p class="cart-drawer__item-title">${escape(item.product_title)}</p><p class="cart-drawer__item-price">${money(item.final_line_price)}</p></div>
      <p class="cart-drawer__item-sub">${escape(item.variant_title === 'Default Title' ? '' : item.variant_title)}</p>
      <div class="cart-drawer__item-bottom"><div class="cart-drawer__qty"><button type="button" data-qty="-1" data-key="${escape(item.key)}" aria-label="Diminuer la quantité">−</button><span>${item.quantity}</span><button type="button" data-qty="1" data-key="${escape(item.key)}" aria-label="Augmenter la quantité">+</button></div><button type="button" class="cart-drawer__item-remove" data-remove="${escape(item.key)}">Retirer</button></div></div></div>`).join('');
    $('[data-cart-empty]').style.display = cart.item_count ? 'none' : 'flex';
    $('[data-cart-summary]').hidden = !cart.item_count;
    $$('[data-cart-count],.header__cart-count').forEach(el => el.textContent = cart.item_count);
    $$('.header__cart').forEach(el => el.setAttribute('aria-label', `Panier (${cart.item_count})`));
    $('[data-cart-subtotal]').textContent = money(cart.original_total_price);
    $('[data-cart-total]').textContent = money(cart.total_price);
    $('[data-cart-discount-line]').hidden = !cart.total_discount;
    $('[data-cart-discount]').textContent = '−' + money(cart.total_discount);
    $('[data-cart-shipping]').textContent = 'Gratuite en France';
    const ship = $('[data-cart-ship]');
    ship.hidden = !cart.item_count;
    $('[data-cart-ship-text]').textContent = 'Livraison gratuite en France, sans minimum d’achat';
  }
  function openCart() {
    lastFocus = document.activeElement;
    render();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.inert = false;
    backdrop.hidden = false;
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('button').focus();
  }
  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    backdrop.hidden = true;
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    lastFocus?.focus();
  }
  $$('[data-cart-open]').forEach(el => el.addEventListener('click', async event => {
    event.preventDefault(); openCart();
    try { cart = await request('cart.js'); render(); } catch (error) { showError(error.message); }
  }));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', event => { event.preventDefault(); closeCart(); }));
  const form = $('#ph-form');
  const productNode = $('#pc-product-data');
  if (form && productNode) {
    const product = JSON.parse(productNode.textContent);
    const button = form.querySelector('[name="add"]');
    const mobileBar = document.createElement('div');
    mobileBar.className = 'pc-mobile-buy';
    mobileBar.hidden = true;
    mobileBar.innerHTML = '<strong data-mobile-price></strong><button type="button">Ajouter au panier</button>';
    document.body.append(mobileBar);
    const mobileButton = mobileBar.querySelector('button');
    mobileButton.addEventListener('click', () => form.requestSubmit(button));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        mobileBar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0;
      }, {threshold: 0}).observe(form.closest('.ph') || form);
    }
    function syncPack(clearError = true) {
      const variant = product?.variants?.find(item => String(item.id) === form.querySelector('[data-ph-id]').value);
      button.disabled = busy || !variant?.available;
      mobileButton.disabled = button.disabled;
      if (variant) $('[data-ph-price]').textContent = money(variant.price);
      mobileBar.querySelector('[data-mobile-price]').textContent = variant ? money(variant.price) : '';
      if (clearError) showError(!variant ? 'Ce produit est momentanément indisponible.' : !variant.available ? 'Ce pack est épuisé.' : '', $('[data-product-error]'));
    }
    $$('.ph__pack').forEach((pack, index) => {
      const variant = product?.variants?.[index];
      const radio = pack.querySelector('input');
      if (variant) {
        pack.dataset.price = money(variant.price);
        pack.querySelector('.ph__pack-price').textContent = money(variant.price);
        const per = pack.querySelector('.ph__pack-per');
        if (per) per.textContent = `soit ${money(Math.floor(variant.price / [1, 3, 5][index]))} /flacon`;
        radio.disabled = !variant.available;
        radio.checked = index === 0;
      }
      pack.addEventListener('click', () => queueMicrotask(syncPack));
      radio.addEventListener('change', () => { pack.click(); syncPack(); });
    });
    if (product?.variants?.[0]) form.querySelector('[data-ph-id]').value = product.variants[0].id;
    syncPack();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || button.disabled) return;
      busy = true; button.disabled = true; mobileButton.disabled = true; button.setAttribute('aria-busy', 'true');
      showError('', $('[data-product-error]'));
      try {
        await request('cart/add.js', {items:[{id: Number(form.querySelector('[data-ph-id]').value), quantity: 1}]});
        cart = await request('cart.js');
        openCart();
      } catch (error) { showError(error.message, $('[data-product-error]')); }
      finally { busy = false; button.removeAttribute('aria-busy'); syncPack(false); }
    });
  }
  drawer.addEventListener('click', async event => {
    const button = event.target.closest('[data-qty],[data-remove]');
    if (!button || busy) return;
    const key = button.dataset.key || button.dataset.remove;
    const item = cart.items.find(item => item.key === key);
    if (!item) return;
    busy = true; drawer.setAttribute('aria-busy', 'true'); showError('');
    try {
      cart = await request('cart/change.js', {id: key, quantity: button.dataset.remove ? 0 : Math.max(0, item.quantity + Number(button.dataset.qty))});
      render();
    } catch (error) { showError(error.message); }
    finally { busy = false; drawer.removeAttribute('aria-busy'); }
  });
  document.addEventListener('keydown', event => {
    if (!drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeCart();
    if (event.key === 'Tab') {
      const elements = [...drawer.querySelectorAll('button,a,input')].filter(el => el.offsetParent !== null && !el.disabled);
      if (event.shiftKey && document.activeElement === elements[0]) { event.preventDefault(); elements.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === elements.at(-1)) { event.preventDefault(); elements[0].focus(); }
    }
  });
  $('[data-cart-promo-form]')?.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    const code = $('[data-cart-promo-input]').value.trim();
    if (!code) return;
    busy = true;
    const button = $('[data-cart-promo-apply]'); button.disabled = true;
    const output = $('[data-cart-promo-error]');
    try {
      cart = await request('cart/update.js', {discount: code});
      render();
      const accepted = cart.discount_codes?.some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
      output.hidden = false;
      output.textContent = accepted ? 'Code appliqué à votre panier.' : 'Ce code ne s’applique pas à votre panier.';
    } catch (error) { showError(error.message, output); }
    finally { busy = false; button.disabled = false; }
  });
  const dialog = $('#pc-info');
  const info = (title, content) => {
    dialog.querySelector('h2').textContent = title;
    dialog.querySelector('.pc-dialog-body').textContent = content;
    dialog.showModal();
  };
  dialog.querySelectorAll('button').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  const copy = {
    communaute: ['Le club des chasseurs de taches', 'Les réseaux sociaux Pschitt Club seront annoncés ici.'],
    livraison: ['Livraison & délais', 'La livraison est gratuite en France, sans minimum d’achat. Pour les autres destinations, les options et tarifs sont affichés au paiement.'],
    paiement: ['Paiement sécurisé', 'Le paiement est pris en charge par Shopify. Les moyens de paiement disponibles sont affichés au checkout.']
  };
  $$('[data-info]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    const key = link.dataset.info;
    if (['avis', 'aide', 'conseils', 'a-propos'].includes(key)) {
      const target = key === 'avis' ? '#temoignages' : key === 'a-propos' ? '#surfaces' : '#faq';
      const element = $(target);
      if (element) element.scrollIntoView({behavior: 'smooth'}); else location.href = root + target;
      return;
    }
    if (['contact', 'ambassadeur', 'presse', 'recrutement'].includes(key)) { location.href = root + 'pages/contact'; return; }
    const policies = {retours:'refund-policy', cgv:'terms-of-service', confidentialite:'privacy-policy', cookies:'privacy-policy', 'mentions-legales':'legal-notice'};
    if (policies[key]) { location.href = root + 'policies/' + policies[key]; return; }
    info(...(copy[key] || [link.textContent.trim(), 'Contactez-nous pour obtenir cette information.']));
  }));
  render();
})();
